import { ComponentChildren } from "preact";
import { LogoData } from "@/lib/logos/logo-data.ts";

function findLogo(name: string) {
  name = name.toLowerCase();

  for (const logoId in LogoData) {
    const logo = LogoData[logoId];
    if (logo.alt.toLowerCase() == name) return logo;
  }

  throw new Error("Logo not found: " + name);
}

export function Logo(props: { id: string }) {
  const logo = findLogo(props.id);

  if (!logo) return <img alt={props.id} />;

  return (
    <img
      key={props.id}
      src={logo.url || ""}
      alt={logo.alt}
      loading="lazy"
      class="partner-logo"
      width={logo.width}
      height={logo.height}
    />
  );
}

export function Logos(props: { children: ComponentChildren }) {
  return <div className="logos">{props.children}</div>;
}


export function AllLogos() {
  const logos = [];
  for (const logoId in LogoData) {
    logos.push(logoId);
  }

  return logos.map(l => <Logo id={l} key={l} />);
}